<template>
<div>
  <div class="app-content content devcontent ">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
            <div class="container-fluid">
               <div class="row breadcrumbs-top">
                  <div class="col-md-12 content-header-left px-0">
                    <h3 class="content-header-title float-left mb-0" > Global Search </h3>
                    
                    <div class="breadcrumb-wrapper">
                      <ol class="breadcrumb">
                        <li class="breadcrumb-item"><router-link to='/'>Dashboard</router-link></li>
                        <li class="breadcrumb-item">Search Details</li>
                      </ol>
                    </div>
                  </div>
               </div>
            </div>
        </div>
        <section>
          <div class="card container px-0">
            <div class="card-header px-0  common_top_title_searchbgst_dock">
              <div class="container-fluid " >
                <div class="row row fc_my-05">
                  <div class="w-auto px-1 mobile-padding-0-2">
                    <div class="avatar bg-light-secondary rounded d-inline-flex mr-1" >
                      <div class="avatar-content"> 
                        <em class="las la-vector-square i_icon_st font-medium-5"></em>
                      </div>
                    </div>
                    <h4 class="card-title d-inline-flex ml-0 mb-0">Search Results {{ results.length ? '(Total '+results.length + ')' : ""}}</h4>
                  </div>
                </div> 
                            
              </div>
            </div>
            
            <div class=" p-1 outboundview_designmobileview5">
              <div class="second_outboundview_design">
                <div class="container px-0">
                  <div class="row match-height" v-if="!showTableResult">
                      <div class="col-sm-6 col-md-4"> 
                          <div class="jumbotron_bg dashboard_third_dview">
                              <div class="palletstrip"> {{ dock ? dock : "No Dock Selected" }}</div>
                              <vue-element-loading :active="isPalletLoading" color="#800080"/>
                              <ul v-if="pallets.length && pallets[0].pallet_code">

                                  <!-- <template v-for="(palletObj, idx) in pallets">
                                      <template v-for="(pallet, idx2) in palletObj.pallet_code.split(',')">
                                          <li :class="[ getPalletCurrentWeight(pallet)  > 500 ? 'heavy' : '', 'pallet']" class="pallet" :id="dock+'___'+sector+'___'+pallet" @click="selectPallet($event, pallet, palletObj.gate_entry_id, idx)">
                                          {{pallet}}
                                          </li>
                                      </template>
                                      
                                  </template> -->
                                  <!-- <template v-for="(count, cidx) in Array(36-pallets[0].pallet_code.split(',').length).fill(0)">
                                      <li style="background-color: #fff">L {{cidx+pallets[0].pallet_code.split(',').length+1}}</li>
                                  </template> -->
                                  <template v-for="(palletObj, idx) in pallets.slice(0,1)">
                                      <template v-for="(count, cidx) in Array(36).fill(0)">
                                          <li 
                                              style="position:relative" 
                                              v-if="getPalletCode(pallets[0].pallet_code, cidx)[1]" 
                                              :class="[ getPalletCurrentWeight(getPalletCode(pallets[0].pallet_code, cidx)[0], getPalletCode(pallets[0].pallet_code, cidx)[1])  >= 2000 ? 'heavy' : '', 'pallet']" 
                                              class="pallet" 
                                              :id="dock+'___'+sector+'___'+getPalletCode(pallets[0].pallet_code, cidx)[0]" 
                                              @click="selectPallet($event, getPalletCode(pallets[0].pallet_code, cidx)[0], palletObj.gate_entry_id, idx)" >
                                              <span class="top-badge">{{getPalletCode(pallets[0].pallet_code, cidx)[2]}}</span>
                                              {{getPalletCode(pallets[0].pallet_code, cidx)[0]}}    
                                          </li>
                                          <li v-else style="background-color: #fff">{{getPalletCode(pallets[0].pallet_code, cidx)[0]}}</li>
                                      </template>
                                  </template>
                              </ul>
                              <ul v-else>
                                  <template v-for="(count, cidx) in Array(36).fill(0)">
                                      <li style="background-color: #fff; position:relative">L{{ cidx+1 <= 9 ? '0'+(cidx+1) : cidx+1}}</li>
                                  </template>
                              </ul>
                          </div>
                      </div>
                      <div class="col-sm-6 col-md-8"> 
                          <div class="jumbotron_bg dashboard_third_dview p-0">
                              <vue-element-loading :active="isPackagesLoading" color="#FF6700"/>
                              <div class="row mx-0 mt-1  match-height customAnimation">

                                  <div class="col-lg-6 col-sm-6 col-12 card_crossdock_main_padding">
                                      <div class="card cursor-pointer card_bottom_line_animation  mb-1" >
                                          <div class="card-header p-1">
                                          <div class="task-count-width_w">
                                              <p class="card-text mx-0">{{sector}} </p>
                                              <h2 class="font-weight-bolder mb-0" >{{roundNumber(getTotalWeightOnSector())}} KG</h2>
                                          </div>
                                          <div class=" bg-light-default p-50 m-0">
                                              <div class="avatar-content avatar_iconsview1">
                                                  
                                                  <img alt=""  class="img-reponsive" src="../../public/images/icons/kg.png">
                                              </div>
                                          </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-lg-6 col-sm-6 col-12 card_crossdock_main_padding">
                                  <div class="card cursor-pointer card_bottom_line_animation bottom_bg_bor3bg mb-1" >
                                      <div class="card-header p-1">
                                      <div class="task-count-width_w">
                                          <p class="card-text mx-0">{{pallet ? pallet : "Pallet Not Selected"}} {{pallet ? ' (Package Details)' : ""}} </p>
                                          <h5 class="font-weight-bolder mb-0" >{{pallet ? 'Total = ' + totalcount : ''}} </h5>
                                          <h5 class="font-weight-bolder mb-0" >{{pallet ? 'Pallet Weight = ' + roundNumber(getPalletCurrentWeight(pallet)) + 'KG' : ''}} </h5>
                                      </div>
                                      <div class=" bg-light-default p-50 m-0">
                                          <div class="avatar-content avatar_iconsview1">
                                              <img alt=""  class="img-responsive" src="../../public/images/icons/pakeges.png">  
                                          </div>
                                      </div>
                                      </div>
                                  </div>
                              </div>
                              </div>
                              <div class="container">
                                   <div class="table-responsive">
                                      
                                      <table class="table table-bordered">
                                          <thead>
                                              <tr>
                                              <th> Package No. </th>
                                              <th> Docket No. </th>
                                              <th> Delivery OU </th>
                                              <th> Package OU </th>
                                              <th> Package Weight (KG)</th>
                                              <th> ADD </th>
                                              <th> Ageing </th>
                                              </tr>
                                              
                                          </thead>
                                          <tbody>
                                              <template v-for="(packageDetails, idx) in packages">
                                                  <tr v-if="searchTerm == packageDetails.shipment_awb || searchTerm == packageDetails.docket_no" class="highlight-search">
                                                      <td > {{packageDetails.shipment_awb}}</td>
                                                      <td > {{packageDetails.docket_no}}</td>
                                                      <td> {{packageDetails.delivery_ou}}</td>
                                                      <td> {{packageDetails.booking_ou}}</td>
                                                      <td> {{roundNumber(packageDetails.package_weight)}}</td>
                                                      <td> {{formatDate(packageDetails.add_date)}}</td>
                                                      <td> {{convertMinutesToTime3(packageDetails.ageing)}}</td>
                                                  </tr>
                                                  <tr v-else>
                                                      <td > {{packageDetails.shipment_awb}}</td>
                                                      <td > {{packageDetails.docket_no}}</td>
                                                      <td> {{packageDetails.delivery_ou}}</td>
                                                      <td> {{packageDetails.booking_ou}}</td>
                                                      <td> {{roundNumber(packageDetails.package_weight)}}</td>
                                                      <td> {{formatDate(packageDetails.add_date)}}</td>
                                                      <td> {{convertMinutesToTime3(packageDetails.ageing)}}</td>
                                                  </tr>
                                              </template>
                                          </tbody>
                                          <template v-if="!packages.length">
                                              <tr>
                                                  <td colspan="6">No packages to show</td>
                                              </tr>
                                          </template>
                                      </table>
                                   </div>
                              </div>
                          </div>
                          <div class="pageCenter text-center mt-4 pagination_viewallpages">
                              <pagination v-model="page" :records="totalcount" :per-page="pagelimit" @paginate="(e) => handlePageChange(e, 'gate_entry_pass')"/>
                          </div>
                      </div>
                  </div>
                  <div class="second_outboundview_design" v-else>
                    <div class="container px-0">
                      <div class="table-responsive">
                        <table class="table table-bordered">
                          <thead>
                              <tr>
                              <th> Docket No. </th>
                              <th> Package No. </th>
                              <th> Sector Name </th>
                              <th> Pallet Location No. </th>
                              <th> Pallet Barcode No. </th>
                              </tr>
                          </thead>
                          <tbody>
                            <vue-element-loading :active="isLoading" color="#FF6700"/>
                            <template v-for="(data, index) in results">
                              <tr>
                                <td> {{data.docket_no ? data.docket_no : "-" }}</td>
                                <td> {{data.shipment_awb}}</td>
                                <td> {{data.zone_name}}</td>
                                <td> {{data.target_location_code ? data.target_location_code : "-"}}</td>
                                <td> {{data.pallet_code ? data.pallet_code : "-"}}</td>
                              </tr>
                            </template>
                            <template v-if="!results.length">
                              <tr>
                                <td colspan="5">No details to show</td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
              </div>
              </div>
            </div>
          </div>
        </section>
      </div>
  </div>
</div>
</template>


<script>
import VueElementLoading from 'vue-element-loading';
import Loading from 'vue-loading-overlay';
import common_methods from "../utils/common_methods"
import searchMasterNameList from "../utils/searchMasterNameList"
import 'vue-loading-overlay/dist/vue-loading.css'
import { EventBus } from '../main'
import CONSTANT from "../constants.js"
import Pagination from 'vue-pagination-2'

export default {
  name: 'GlobalSearch',
  mixins: [ common_methods, searchMasterNameList ],
  components: {
    VueElementLoading,
    Loading,
    Pagination,
  },
  data() {
    return {
      isLoading: false,
      results: [],
      showTableResult: false,
      searchTerm: null,
      isPalletLoading: false,
      isPackagesLoading: false,
      isShipmentSummaryLoading: false,
      docks: [],
      pallets: [],
      palletMaster: [],
      pallet_code: "",
      gate_entry_id: 0,
      packages: [],
      totalcount: 0,
      pageCount: 0,
      page: 1,
      pagelimit: CONSTANT.LIMIT,
      currPageNum: 0,
      pageoffset: 1,
      palletWeight: [],
      no_of_packages: 0,
      isPackageLoading: false,
      sector: "",
      dock: "",
      pallet: "",
    }
  },
  created() {
  },
  mounted() {
    this.searchTerm = this.$route.query.query
    this.getSearchResults()
    try {
      if(typeof EventBus !== 'undefined') {
        EventBus.$on('searchTerm', searchQ => {
          this.searchTerm = searchQ
          this.getSearchResults(this.searchTerm)
        })
      }
    } catch(e) {
      this.$router.push('/mydashboard')
    }
  },
  methods: {
    resetPagination() {
      this.page = 1
      this.currPageNum = 0
      this.pageoffset = 1
      this.totalcount = 0
    },
    getSearchResults() {
      this.showTableResult = false
      this.results = []
      this.isLoading = true
      let url = `/search-details?query=${this.searchTerm}`
      this.makeRequest("GET", url)
        .then(result => {
          this.isLoading = false
          this.results = result.data
          if(this.results.length) {
            this.dock = this.results[0].dock_name
            this.sector = this.results[0].zone_name
            if(this.sector && this.dock) {
              this.getPalletsOnSector(this.sector, this.dock, this.results[0].dock_location)
            } else {
              this.showTableResult = true
            }
          }
        })
        .catch(e => {
          this.isLoading = false
          this.displayError(e)
        })
    },
    getPalletsOnSector(sector, dock_name) {
      this.isPalletLoading = true
      let url = `/floor/pallets?type=Outbound`
      this.makeRequest("POST", url, { sector, dock_name })
        .then(result => {
          this.isPalletLoading = false
          this.pallets = result.data.pallets
          this.palletWeight = result.data.palletWeight
        })
        .catch(e => {
          this.isPalletLoading = false
          this.displayError(e)
        })
    },
    getPalletCode(pallets, index) {
      let currentLocationCode = index + 1 <= 9 ? `L0${index+1}`:`L${index+1}`
      if(pallets) {
          pallets = pallets.split(",")
      } else {
          return [currentLocationCode, false, currentLocationCode]
      }
      let pallet = pallets.find(p => p.split('___')[1] === currentLocationCode)
      if(pallet)  return [pallet.split('___')[0], true, currentLocationCode]
      return [currentLocationCode, false, currentLocationCode]
    },
    getTotalWeightOnSector() {
      return this.palletWeight.reduce((a, c) => a + Number(c.current_weight), 0)
    },
    getPalletCurrentWeight(pallet_code) {
      let obj = this.palletWeight.find(p => p.pallet_code === pallet_code)
      if(obj) {
          return Number(obj.current_weight)
      }
      return 0
    },
    selectPallet(e, pallet_code, gate_entry_id, index) {
      this.resetPagination()
      let allPalletListElements = document.getElementsByClassName("pallet")
      for(let element of allPalletListElements) {
          element.classList.remove("active")
      }
      let palletElement = e.target
      palletElement.classList.add("active")
      if(this.pallet !== pallet_code) {
          this.packages = []
          this.pallet = pallet_code
          this.gate_entry_id = gate_entry_id
          this.getPackagesOnPallet(pallet_code, gate_entry_id)
      }
    },
    getPackagesOnPallet(pallet_code, gate_entry_id) {
      this.isPackagesLoading = true
      let url = `/floor/pallets/packages`
      let payload = {
          page: this.page,
          rows: this.pagelimit
      }
      this.makeRequest("POST", url, { ...payload, pallet_code, gate_entry_id, sector: this.sector, dock_name: this.dock })
          .then(result => {
              this.isPackagesLoading = false
              this.packages = result.data.data.rows
              this.totalcount = result.data.data.count
              this.pageCount = Math.ceil(result.data.data.count / this.pagelimit)
          })
          .catch(e => {
              this.isPackagesLoading = false
              this.displayError(e)
          })
    },
  }
}
</script>
<style scoped>
.high_weight {
    background-color: #F7993F;
    cursor: pointer;
    color: #292626;
    border-radius: 0px!important;
    border: 1px solid #d6811c;
}

.heavy {
    background-color: red;
    color: #fff;
}

li {
    list-style: none
}
.sector:hover, .pallet:hover {
    cursor: pointer;
    background-color: #19A873;
    color: #fff

}
.btn--export {
    border: none;
    padding: 6px 12px;
    color: #000;
    background: #fff;
    font-weight: 500
}
.btn--export:hover {
    color: #fff;
    background: #000
}
.top-badge {
    position: relative;
    left: 0px;
    top: 0px;
    background-color: #f9f9f9;
    border: 0.6px solid #cbcaca;
    color: #464646;
    padding: 0px 1px;
    font-size: 12px;
    border-radius: 2px;
}
.highlight-search {
  font-weight: bold
}
</style>